import React from 'react'
import { getCountryCodeByName, getCountryData } from 'utils/getCountryList'
import { Country } from 'types'

export const renderCustomAxisTick = (
  { payload, y, x }: { payload: { value: string }; y: number; x: number },
  countryTicks: {
    countryName: string
    rank: number
    color: string
  }[],
) => {
  return (
    <g transform={`translate(${x - 10},${y - 20})`}>
      <text x={0} y={0} dy={16} textAnchor='start' fill='black' transform='rotate(-60)' fontSize='0.7em'>
        {countryTicks.find((countryTick) => countryTick.rank === Number(payload.value))!.countryName}
      </text>
    </g>
  )
}

export const CustomizedDot = (props: any) => {
  const { cx, cy, stroke, index, value, activeStroke, onMouseOver, onMouseOut, isHovered, onClickFunc } = props

  return (
    <svg
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={() => {
        onClickFunc(index)
      }}
    >
      {/* Define the shadow filter */}
      <defs>
        <filter id='shadowDot' x='-50%' y='-50%' width='200%' height='200%'>
          <feOffset result='offOut' in='SourceGraphic' dx='5' dy='5' />
          <feColorMatrix
            result='matrixOut'
            in='offOut'
            type='matrix'
            values='0 0 0 0 0
                  0 0 0 0 0
                  0 0 0 0 0
                  0 0 0 0.5 0'
          />
          <feGaussianBlur result='blurOut' in='matrixOut' stdDeviation='3' />
          <feBlend in='SourceGraphic' in2='blurOut' mode='normal' />
        </filter>
      </defs>

      <rect
        x={cx - 10}
        y={cy - 10}
        width={20}
        height={20}
        rx={6} // rx is used for border radius in SVG rect
        ry={6} // ry is used for border radius in SVG rect
        fill={activeStroke || stroke}
        filter={isHovered ? 'url(#shadowDot)' : undefined} // Apply the shadow filter
      />
      {index === 0 && (
        <text x={value < 10 ? cx - 3 : cx - 6} y={cy + 4} fontSize='0.7em'>
          {value}
        </text>
      )}
    </svg>
  )
}

// Function to update the active coordinate
export const handleMouseMove = (
  state: any,
  isHovered: boolean,
  // setActiveCoordinate: React.Dispatch<
  //   React.SetStateAction<{
  //     x: number
  //     y: number
  //   }>
  // >,
  width: number,
) => {
  if (state?.isTooltipActive && isHovered) {
    // setActiveCoordinate({
    //   x: state.activeCoordinate.x < width - 200 ? state.activeCoordinate.x - 30 : state.activeCoordinate.x - 230,
    //   y: state.chartY - 90,
    // })
  } else {
    // setActiveCoordinate({ x: 0, y: 0 })
  }
}

export const onClickDotFunc = (
  yearIndex: number,
  countryTick: {
    countryName: string
    rank: number
    color: string
  },
  yearRange: number[],
  countryData: Country[],
  { setViewType, setRanking, setCountry, setCurrentYear }: any,
) => {
  const countryDataList = getCountryData(countryData)
  setViewType('bar')
  setRanking({ ranking: 'national' })
  setCountry({
    country: getCountryCodeByName(countryTick.countryName, countryDataList) as string,
  })

  setCurrentYear(yearRange[yearRange.length - yearIndex - 1])
}
